'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
const react_1 = require('react');
const config_1 = require('./utils/config');
function useBreakpoints() {
  const [breakpoint, setBreakpoint] = (0, react_1.useState)('xl');
  const updateMedia = () => {
    const bp =
      Object.keys(config_1.breakpoints).find(
        size => window.innerWidth < config_1.breakpoints[size]
      ) || 'xl';
    setBreakpoint(bp);
  };
  (0, react_1.useEffect)(() => {
    updateMedia();
    window.addEventListener('resize', updateMedia);
    return () => window.removeEventListener('resize', updateMedia);
  });
  return breakpoint;
}
exports.default = useBreakpoints;
//# sourceMappingURL=useBreakpoints.js.map
